import { render } from "./AddMarqueModal.vue?vue&type=template&id=6376e3e0&ts=true"
import script from "./AddMarqueModal.vue?vue&type=script&lang=ts"
export * from "./AddMarqueModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__